import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"

import { AboutRoutingModule } from "./about-routing.module"
import { OurMissionComponent } from "./our-mission/our-mission.component"
import { TrustAndPrivacyComponent } from "./trust-and-privacy/trust-and-privacy.component"
import { AboutComponent } from "./about.component"
import { SharedComponentsModule } from "../shared-components/shared-components.module"
import { OurContentComponent } from "./our-content/our-content.component"
import { FooterNavComponent } from "./footer-nav/footer-nav.component"
import { AboutMobileMenuComponent } from "./mobile-menu/about-mobile-menu.component"
import { TeachingWithPbsComponent } from "./teaching-with-pbs/teaching-with-pbs.component"
import { OurImpactComponent } from "./our-impact/our-impact.component"
import { BentoComponent } from "./bento-component/bento.component"

@NgModule({
    declarations: [
        OurMissionComponent,
        TrustAndPrivacyComponent,
        AboutComponent,
        OurContentComponent,
        FooterNavComponent,
        AboutMobileMenuComponent,
        TeachingWithPbsComponent,
        OurImpactComponent,
        BentoComponent,
    ],
    imports: [CommonModule, AboutRoutingModule, SharedComponentsModule],
})
export class AboutModule {}
